import type { ConfigSismaDTO } from '../../dto/plc/config-sisma-dto'
import type { SeismicConfiguration } from '../../types/plc/seismic-configuration'

const mapToSeismicConfiguration = (configSismaDto: ConfigSismaDTO): SeismicConfiguration => {
    return {
        id: configSismaDto.id,
        horizontalCurvatureThreshold: configSismaDto.slcOrizzontale,
        horizontalDeformationThreshold: configSismaDto.sldOrizzontale,
        horizontalLevelThreshold: configSismaDto.sloOrizzontale,
        horizontalVelocityThreshold: configSismaDto.slvOrizzontale,
        verticalCurvatureThreshold: configSismaDto.slcVerticale,
        verticalDeformationThreshold: configSismaDto.sldVerticale,
        verticalLevelThreshold: configSismaDto.sloVerticale,
        verticalVelocityThreshold: configSismaDto.slvVerticale,
    }
}

const mapToConfigSismaDTO = (seismicConfiguration: SeismicConfiguration): ConfigSismaDTO => {
    return {
        id: seismicConfiguration.id,
        slcOrizzontale: seismicConfiguration.horizontalCurvatureThreshold,
        sldOrizzontale: seismicConfiguration.horizontalDeformationThreshold,
        sloOrizzontale: seismicConfiguration.horizontalLevelThreshold,
        slvOrizzontale: seismicConfiguration.horizontalVelocityThreshold,
        slcVerticale: seismicConfiguration.verticalCurvatureThreshold,
        sldVerticale: seismicConfiguration.verticalDeformationThreshold,
        sloVerticale: seismicConfiguration.verticalLevelThreshold,
        slvVerticale: seismicConfiguration.verticalVelocityThreshold,
    }
}

export { mapToConfigSismaDTO, mapToSeismicConfiguration }
